/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';
import logo from '../assets/logo.png';
import { useAuth } from '../context/AuthContext';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { currentLogoUrl, user } = useAuth();

  const isSubAccountContext = !!user?.subAccountUID;
  const mobileLogoSrc = currentLogoUrl || logo;
  const mobileLogoAlt = (isSubAccountContext && currentLogoUrl) ? 'Sub-Account Logo' : 'Send2Me Logo';

  return (
    <div className="flex flex-col lg:flex-row h-screen overflow-hidden lg:p-4 lg:gap-4 bg-slate-950/5">
      {/* Mobile Header */}
      <div className="lg:hidden flex items-center justify-between p-4 bg-primary text-white shadow-lg z-30">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white shadow-lg shadow-sky-500/20 rounded-xl flex items-center justify-center p-1.5">
            <img
              src={mobileLogoSrc}
              alt={mobileLogoAlt}
              className="w-auto max-w-[70px] h-[30px] max-h-[30px] object-contain"
              onError={(e) => { e.currentTarget.src = logo; e.currentTarget.onerror = null; }}
            />
          </div>
          <span className="font-bold text-xl tracking-tight custom-line-break">{user?.subAccountName || 'Send2Me'}</span>
        </div>
        <button
          onClick={() => setSidebarOpen(true)}
          className="p-2 hover:bg-white/10 rounded-xl transition-colors"
        >
          <Menu size={24} />
        </button>
      </div>

      {/* Sidebar Container */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isCollapsed={isCollapsed}
        onToggleCollapse={() => setIsCollapsed(!isCollapsed)}
      />

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto lg:glass-panel lg:rounded-xl p-2">
        <div className="">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
